// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ececc0a5","726":"e95d974a"}[chunkId] + ".chunk.js";
};